import { createElementFromHtml } from '@Support/create-element-from-html';
import { fadeIn } from '@Support/effects/fade-in';

export class BodyLoader {
    $loader = null;
    #config = {
        id: 'ci-body-loader',
        parentEl: null,
        parentSelector: 'body',
        resizeToParent: false,
        timeout: 5000,
        message: '',
        imageSrc: '',
        innerTemplate: '<span class="h-100p w-100p flex-xyc absolute i-1"><img class="max-w-22" src="{{imageSrc}}" /></span>',
        bodyLock: true,
        bodyLockClass: 'ci-body-loader-lock'
    };
    #state = {
        timeout: false,
        message: false
    };

    constructor(initialConfig) {
        if (initialConfig) {
            this.setConfig(initialConfig);
        }
    }

    setConfig(config) {
        Object.assign(this.#config, config);
    }

    init() {
        const $loader = document.getElementById(this.#config.id);

        if ($loader) {
            this.$loader = $loader;
        } else {
            this.#createLoaderElement();
        }
    }

    show() {
        const timeout = this.#state.timeout || this.#config.timeout;

        if (this.#config.bodyLock) {
            document.getElementsByTagName('body')[0].classList.add(this.#config.bodyLockClass);
        }

        let $message = null;
        if (this.#state.message !== false) {
            $message = this.$loader.querySelector('.ci-body-loader-message');
            $message.textContent(this.#state.message);
        }

        fadeIn({ $el: this.$loader, duration: 200 });

        setTimeout(() => { // for bfcache
            this.hide();
            this.#state.timeout = false;
            this.#state.message = false;

            if ($message) {
                $message.textContent(this.#config.message);
            }
        }, timeout);
    }

    hide() {
        if (this.#config.bodyLock) {
            document.getElementsByTagName('body')[0].classList.remove(this.#config.bodyLockClass);
        }

        this.$loader.style.setProperty('display', 'none');
    }

    setTimeoutOnce(timeout) {
        this.#state.timeout = timeout;
    }

    setMessageOnce(message) {
        this.#state.message = message;
    }

    #createLoaderElement() {
        if (this.#config.imageSrc) {
            this.#config.innerTemplate = this.#config.innerTemplate.replace('{{imageSrc}}', this.#config.imageSrc);
        } else {
            this.#config.innerTemplate = '';
        }

        this.$loader = createElementFromHtml(
            `<div id="${this.#config.id}" class="ci-body-loader">
                ${this.#config.innerTemplate}
                <div class="ci-body-loader-message">
                    ${this.#config.message}
                </div>
            </div>`
        );

        if (this.#config.parentEl) {
            this.#config.parentEl.prepend(this.$loader);
        } else {
            const $parent = document.querySelector(this.#config.parentSelector);
            $parent.prepend(this.$loader);
        }


        if (this.#config.resizeToParent) {
            this.$loader.style.setProperty('width', '100%');
            this.$loader.style.setProperty('height', '100%');
            this.$loader.style.setProperty('position', 'absolute');
        }
    }
}